import type { ReactNode } from 'react'
import { Flex, Typography } from 'antd'

/** 页面标题区，统一各模块页头 */
export function PageHeader({
  title,
  desc,
  action,
}: {
  title: string
  desc?: string
  action?: ReactNode
}) {
  return (
    <Flex justify="space-between" align="center" style={{ marginBottom: 10 }}>
      <div>
        <Typography.Title level={4} style={{ margin: 0, fontSize: 16, lineHeight: '32px' }}>
          {title}
        </Typography.Title>
        {desc && (
          <Typography.Text type="secondary">{desc}</Typography.Text>
        )}
      </div>
      {action}
    </Flex>
  )
}
